import styled from '@emotion/styled';

const BenefitTableRedesign = styled.table`
  width: 100%;
  padding-bottom: 1em;
  font-family: ${props => props.theme.fontFamily};
  line-height: 1.42857143;
  table-layout: fixed;
  border-collapse: collapse;
  margin-bottom: 1em;
  border-bottom: 1px solid #ddd;
`;
export default BenefitTableRedesign;

export const BenefitTh = styled.th`
background-color: ${props => (props.isDragging ? props.theme.borderColor : 'inherit')};
color: black;
font-size: ${props => props.theme.fontSize_base};
text-align: left;
padding: 10px;
height: 65px;
width: ${props => props.columnWidth || 'auto'};
min-height: 100px;
&:hover {
  background-color: ${props => (props.editAvailable ? props.theme.borderColor : 'inherit')}
}
word-wrap: break-word;
`;

export const SubcategoryTh = styled.th`
background-color: ${props => (props.isDragging ? props.theme.borderColor : 'inherit')};
color: black;
font-size: ${props => props.theme.fontSize_base};
text-align: left;
vertical-align: bottom;
padding: 10px;
height: 65px;
width: ${props => props.columnWidth || 'auto'};
min-height: 100px;
&:hover {
  background-color: ${props => (props.editAvailable ? props.theme.borderColor : 'inherit')}
}
word-wrap: break-word;
`;

export const BenefitTr = styled.tr`
  border-top: 1px solid #ddd;
  /* Maintain cell widths while dragging */
  display: ${props => (props.isDragging ? 'table' : 'table-row')};
  &:nth-of-type(odd) {
    background-color: #fbfbfb;
  }
  &:nth-of-type(even) {
    background-color: #fff;
  }
`;

export const BenefitTd = styled.td`
  cursor: text;
  &:hover {
    background-color: ${props => (props.editAvailable ? props.theme.borderColor : 'inherit')}
  }
  font-size: ${props => props.theme.fontSize_base};
  color: ${props => props.theme.color};
  padding: 10px;
  width: ${props => (props.columnWidth ? props.columnWidth : 'auto')};
  word-wrap: break-word;
`;

export const LegendRedesign = styled.legend`
  display: block;
  width: 100%;
  padding: 0px;
  padding-left: 10px;
  font-size: ${props => props.theme.fontSize_base};
  font-family: ${props => props.theme.fontFamily};
  font-weight: bold;
  &:hover {
    background-color: ${props => (props.editAvailable ? props.theme.borderColor : 'inherit')}
  }
  word-wrap: break-word;
  min-height: 2em;
  margin-top: 35px;
`;

const comparePlansColor = '#e9edf0';

export const ComparePlanNamesTh = styled.th`
  background-color: ${comparePlansColor};
  color: black;
  font-size: ${props => props.theme.fontSize_base};
  text-align: left;
  padding: 10px;
  width: ${props => props.columnWidth || 'auto'};
  &:hover {
    background-color: ${props => (props.editAvailable ? props.theme.borderColor : 'inherit')}
  }
  word-wrap: break-word;
`;

export const CompareCategoryNamesTh = styled.th`
  background-color: ${comparePlansColor};
  color: black;
  border-top: 1px solid black;
  font-size: ${props => props.theme.fontSize_base};
  text-align: left;
  padding: 10px;
  width: ${props => props.columnWidth || 'auto'};
  &:hover {
    background-color: ${props => (props.editAvailable ? props.theme.borderColor : 'inherit')}
  }
  word-wrap: break-word;
`;
